import { useEffect, useRef, useState } from 'react';
import s from './style.module.scss';
import { Display } from '@/components/Display/Display';
import { ArrowsAltOutlined, ShrinkOutlined, ExclamationCircleOutlined, CheckCircleFilled } from '@ant-design/icons';
import { Radio, Input, Progress } from 'antd';
import { errText, placeHolder, styleOptions } from './constants';
import GrtButton from '@/components/Web/GrtButton';
import GrtTextArea from '@/components/Web/GrtTextArea';
import ResultFile from '@/pages/Web/PageComponents/AgentFile/ResultFile';
import { handleGetReviewStatus } from '@/api/grt/evaluation';
import MyIcon from '@/components/MyIcon';
import { Tooltip, Space } from 'antd';
import { Spin } from 'antd';
import { inject, observer } from 'mobx-react';
import { Hide } from '@/components/Hide';
// const mockData = {
//     title: '测试数据',
//     criteria: '',
//     style: styleOptions[1].value,
//     requirements: ''
// };
const Review = (props) => {
    const { sessionStore, chatStore } = props.store;
    const timer = useRef(null);
    const isFirst = useRef(true);
    const [status, setStatus] = useState(null); //-1-评阅第一步  0-点击开始生成，生成中 1--生成完毕
    const { messageInfo } = props;
    const { createRequestByMsgId } = chatStore;
    const { changeOriginMsgMap, getCurSessionMsgs, currentSessionMapId } = sessionStore;
    const { ai_evaluation_item, ai_evaluation_result } = props.ai_evaluation;
    const [expand, setExpand] = useState(true);
    const [customStyle, setCustomStyle] = useState('');
    const [err, setError] = useState({
        title: false,
        criteria: false,
        style: false,
        requirements: false
    });
    //表单数据
    const [formData, setFormData] = useState({
        title: '',
        criteria: '',
        style: styleOptions[0].value,
        requirements: ''
    });
    //结果数据
    const [resData, setResData] = useState({
        progress: '0',
        status: 0,
        text: '',
        files: {}
    });
    const toggleExpand = () => {
        setExpand(!expand);
    };
    const testErr = () => {
        let hasError = false;
        let allKeys = ['criteria', 'style', 'title'];
        let errObj = {};
        allKeys.forEach((key) => {
            let value = formData[key];
            if (key === 'style' && value === '自定义' && customStyle.trim().length === 0) {
                errObj.customstyle = true;
                hasError = true;
            }
            if (value !== undefined && value.trim().length === 0) {
                errObj[key] = true;
                hasError = true;
            }
        });
        setError(errObj);
        return hasError;
    };
    useEffect(() => {
        testErr();
    }, [formData, customStyle]);
    //表单change
    const onChange = (value, key) => {
        setFormData({
            ...formData,
            [key]: value
        });
    };
    //自定义风格change
    const onChangeCustomStyle = (e) => {
        setCustomStyle(e.target.value);
    };
    //提交数据
    const submitData = () => {
        let form = {
            criteria: formData?.criteria,
            title: formData?.title,
            requirements: formData?.requirements
        };
        if (formData.style === '自定义') {
            form.style = {
                custom: true,
                text: customStyle
            };
        } else {
            form.style = {
                custom: false,
                text: formData.style
            };
        }
        let reqData = {
            question: JSON.stringify(form),
            tenant_id: messageInfo?.tenant_id,
            user_id: messageInfo?.user_id,
            agent_id: messageInfo?.agent_id,
            skill_id: messageInfo?.skill_id,
            session_id: messageInfo?.session_id,
            interrupt: true
        };
        createRequestByMsgId(messageInfo?._id || messageInfo?.temId, reqData); //历史记录去id，新消息去临时temId
    };

    //处理初始化数据
    const formatInitData = () => {
        let { style = {} } = ai_evaluation_item;
        let styleText = style?.text || styleOptions[0].value;
        if (style?.custom) {
            setCustomStyle(styleText);
            styleText = '自定义';
        }
        setFormData({
            ...ai_evaluation_item,
            style: styleText
        });
        setResData(ai_evaluation_result);
    };
    //处理结果数据
    useEffect(() => {
        if (ai_evaluation_result && Object.keys(ai_evaluation_result).length) {
            setResData(ai_evaluation_result);
            setStatus(ai_evaluation_result.status);
            if (ai_evaluation_result.status === 0) {
                startTimer();
            } else {
                clearTimer();
            }
        } else {
            setStatus(-1);
        }
    }, [ai_evaluation_result]);
    useEffect(() => {
        if (ai_evaluation_item) {
            formatInitData();
        }
    }, []);
    //修改数据，主要是为了发送消息的时候判断流程是否结束，是否可以发送消息
    //需要把currentSessionId传过来 避免切换会话时会话id已经改变 但是请求结果正好回来 导致数据错乱
    const changeData = (data, currentSessionId) => {
        let msgs = getCurSessionMsgs();
        let len = msgs.length;
        let ai_evaluation_obj = {};
        if (len) {
            msgs[len - 1].ai_evaluation = msgs[len - 1].ai_evaluation || {};
            ai_evaluation_obj = msgs[len - 1].ai_evaluation;
            ai_evaluation_obj.ai_evaluation_result = ai_evaluation_obj.ai_evaluation_result || {};
            ai_evaluation_obj.ai_evaluation_result.status = data.status;
            ai_evaluation_obj.ai_evaluation_result.progress = data.progress;
            ai_evaluation_obj.ai_evaluation_result.files = data.files;
            ai_evaluation_obj.ai_evaluation_result.text = data.text;
        }
        setResData(ai_evaluation_obj.ai_evaluation_result);
        setStatus(data.status);
        console.log('changeData', data, currentSessionId, msgs);
        changeOriginMsgMap({
            [currentSessionId]: {
                messages: msgs
            }
        });
    };

    const clearTimer = () => {
        if (timer.current) {
            clearInterval(timer.current);
            timer.current = null;
        }
    };
    //获取执行结果
    const getTaskStatus = async () => {
        let res = await handleGetReviewStatus({
            session_id: currentSessionMapId
        });
        if (res?.success) {
            changeData(res.data, currentSessionMapId);
        } else {
            clearTimer();
        }
        if (res?.data?.status !== 0) {
            clearTimer();
        }
    };
    //轮询查询结果
    const startTimer = () => {
        if (!timer.current) {
            timer.current = setInterval(() => {
                getTaskStatus();
            }, 5000);
        }
    };

    //点击确定
    const onConfirm = () => {
        let hasError = testErr();

        if (hasError) {
            return false;
        } else {
            submitData();
            setStatus(0);
            // startTimer();
            setExpand(false);
        }
    };
    useEffect(() => {
        //评阅完的要收起
        if (isFirst.current) {
            isFirst.current = false;
            return;
        }

        if (status === -1) {
            setExpand(true);
        } else {
            setExpand(false);
        }
    }, [status]);
    return (
        <div className={s['box-wrap']}>
            <Display show={status === null}>
                <Spin spinning={true} />
            </Display>

            <Display show={status !== null}>
                <div className={s['group-wrap']}>
                    <div className={s['group-title']}>
                        <div className={s['left']}>
                            <MyIcon type="icon-add-info"></MyIcon>
                            <span className={s['text']}>
                                补充信息
                                <Display show={status !== -1}>
                                    <span className={s['icon']}>
                                        <CheckCircleFilled style={{ color: '#52C41A' }} />
                                    </span>
                                </Display>
                            </span>
                        </div>

                        <span className={s['expand']} onClick={toggleExpand}>
                            <Display show={!expand}>
                                <Tooltip title="展开">
                                    <div>
                                        <MyIcon type="icon-zhankai"></MyIcon>
                                    </div>
                                </Tooltip>
                            </Display>
                            <Display show={expand}>
                                <Tooltip title="收起">
                                    <div>
                                        <MyIcon type="icon-shouqi"></MyIcon>
                                    </div>
                                </Tooltip>
                            </Display>
                        </span>
                    </div>

                    <div className={s['review-item-wrap']}>
                        <Hide show={expand}>
                            <div>
                                <div className={s['review-item']}>
                                    <div className={s['title']} style={{ marginTop: 12 }}>
                                        <span data-required={true} className={s['title-span']}>
                                            1.请输入评阅主题
                                        </span>
                                        <Display show={err.title}>
                                            <span className={s['error']}>
                                                <ExclamationCircleOutlined />
                                                {errText.title}
                                            </span>
                                        </Display>
                                    </div>
                                    <div className={s['form-wrap']}>
                                        <GrtTextArea
                                            disabled={status !== -1}
                                            onChange={(e) => {
                                                onChange(e.target.value, 'title');
                                            }}
                                            value={formData.title}
                                            showCount
                                            maxLength={200}
                                            placeholder={placeHolder.title}
                                            rows={4}
                                        />
                                    </div>
                                </div>
                                <div className={s['review-item']}>
                                    <div className={s['title']}>
                                        <span data-required={true} className={s['title-span']}>
                                            2.请输入评阅标准
                                        </span>
                                        <Display show={err.criteria}>
                                            <span className={s['error']}>
                                                <ExclamationCircleOutlined />
                                                {errText.criteria}
                                            </span>
                                        </Display>
                                    </div>
                                    <div className={s['form-wrap']}>
                                        <GrtTextArea
                                            disabled={status !== -1}
                                            onChange={(e) => {
                                                onChange(e.target.value, 'criteria');
                                            }}
                                            value={formData.criteria}
                                            showCount
                                            maxLength={1000}
                                            placeholder={placeHolder.criteria}
                                            rows={8}
                                        />
                                    </div>
                                </div>
                                <div className={s['review-item']}>
                                    <div className={s['title']}>
                                        <span className={s['title-span']}>3.评语风格</span>
                                        <Display show={err.style}>
                                            <span className={s['error']}>
                                                <ExclamationCircleOutlined />
                                                {errText.style}
                                            </span>
                                        </Display>
                                    </div>
                                    <div className={s['form-wrap']}>
                                        {/* <Radio.Group
                                    disabled={status !== -1}
                                    onChange={(e) => {
                                        onChange(e.target.value, 'style');
                                    }}
                                    value={formData.style}
                                    options={styleOptions}
                                /> */}
                                        <Radio.Group
                                            disabled={status !== -1}
                                            onChange={(e) => {
                                                onChange(e.target.value, 'style');
                                            }}
                                            value={formData.style}
                                        >
                                            <Space size={30}>
                                                {styleOptions.map((item) => (
                                                    <Radio key={item.value} value={item.value}>
                                                        {item.label}
                                                    </Radio>
                                                ))}
                                            </Space>

                                            <div className={s['custom-style-wrap']}>
                                                <Radio value="自定义">自定义</Radio>
                                                <Display show={formData?.style === '自定义'}>
                                                    <div className={s['custom-wrap']}>
                                                        <div style={{ width: 250, marginRight: 10 }}>
                                                            <Input
                                                                disabled={status !== -1}
                                                                showCount
                                                                value={customStyle}
                                                                onChange={onChangeCustomStyle}
                                                                maxLength={10}
                                                                placeholder="请输入风格"
                                                            ></Input>
                                                        </div>
                                                        <Display show={err.customstyle}>
                                                            <div className={s['error']}>
                                                                <ExclamationCircleOutlined /> {errText.style}
                                                            </div>
                                                        </Display>
                                                    </div>
                                                </Display>
                                            </div>
                                        </Radio.Group>
                                    </div>
                                </div>
                                <div className={s['review-item']}>
                                    <div className={s['title']}>
                                        <span className={s['title-span']}>4.评语要求</span>
                                    </div>

                                    <div className={s['form-wrap']}>
                                        <GrtTextArea
                                            disabled={status !== -1}
                                            onChange={(e) => {
                                                onChange(e.target.value, 'requirements');
                                            }}
                                            value={formData.requirements}
                                            showCount
                                            maxLength={200}
                                            placeholder={placeHolder.requirements}
                                            rows={4}
                                        />
                                    </div>
                                </div>
                                <Display show={status === -1}>
                                    <div className={s['action-wrap']}>
                                        <GrtButton type="primary" onClick={onConfirm}>
                                            确定
                                        </GrtButton>
                                    </div>
                                </Display>
                            </div>
                        </Hide>
                    </div>
                </div>

                <Display show={status !== -1}>
                    <div className={s['group-wrap']}>
                        <div className={s['res-wrap']} data-expand={expand}>
                            <Display show={status === 0}>
                                <div>信息提交成功，即将开始执行本次评阅任务～</div>
                            </Display>

                            <Display show={status !== 3}>
                                <div className={s['group-title']}>
                                    <div className={s['left']}>
                                        <MyIcon type="icon-start-task"></MyIcon>
                                        <span className={s['text']}>执行任务</span>
                                        <Display show={Number(resData?.progress) !== 100}>
                                            <span className={s['progress']}>
                                                <Progress strokeColor="#FAAD14" size="small" percent={Number(resData?.progress)}></Progress>
                                            </span>
                                        </Display>

                                        <Display show={Number(resData?.progress) === 100}>
                                            <span className={s['icon']}>
                                                <CheckCircleFilled style={{ color: '#52C41A' }} />
                                            </span>
                                        </Display>
                                    </div>
                                </div>
                            </Display>

                            <Display show={status === 1}>
                                <div className={s['group-title']}>
                                    <div className={s['file']}>
                                        <div className={s['file-text']}>{resData?.text}</div>
                                        <ResultFile file={resData?.files}></ResultFile>
                                    </div>
                                </div>
                            </Display>
                            <Display show={status === 3}>
                                <div className={s['group-title']}>
                                    <div className={s['file']}>
                                        <div className={s['file-text']}>{resData?.text}</div>
                                    </div>
                                </div>
                            </Display>
                        </div>
                    </div>
                </Display>
            </Display>
        </div>
    );
};

export default inject('store')(observer(Review));
